APP.toasts = function (options) {
	let toasts, toastsDialog, toastsMain, toastsFoot, btnOk, btnConfirm

	const settings = $.extend(
		{
			wrapper: '.wl-phone-body',
			message: '',
			isConfirm: false,
			onComplete: function () {},
		},
		options
	)

	function init() {
		setup()
		btnOk.on('click', handleOk)
	}

	function setup() {
		handleOk()

		toasts = $(settings.wrapper).append($('<div>').addClass('wl-toasts')).find('.wl-toasts')

		toastsDialog = toasts.append($('<div>').addClass('wl-toasts-dialog')).find('.wl-toasts-dialog')

		gsap.set(toastsDialog, {
			x: -100,
			zIndex: 2,
			y: '-50%',
		})

		BODY.addClass(CLASS._noscroll)
		gsap.set(BODY, {
			paddingRight: APP.getScrollbarWidth(),
		})

		toastsMain = toastsDialog.append($('<div>').addClass('wl-toasts-main')).find('.wl-toasts-main')

		toastsMain
			.append($('<div>').addClass('wl-toasts-body').html(settings.message))
			.find('.wl-toasts-body')

		toastsFoot = toastsMain.append($('<div>').addClass('wl-toasts-foot')).find('.wl-toasts-foot')

		if (settings.isConfirm) {
			btnConfirm = toastsFoot
				.append(
					$('<button>').addClass('wl-btn wl-btn-ok').html('<span>Ok</span>').attr('type', 'button')
				)
				.find('.wl-btn-ok')

			btnOk = toastsFoot
				.append(
					$('<button>')
						.addClass('wl-btn wl-btn-cancel')
						.html('<span>Cancel</span>')
						.attr('type', 'button')
				)
				.find('.wl-btn-cancel')

			btnConfirm.on('click', handleConfirm)
		} else {
			btnOk = toastsFoot
				.append(
					$('<button>').addClass('wl-btn wl-btn-ok').html('<span>Ok</span>').attr('type', 'button')
				)
				.find('.wl-btn-ok')
		}

		gsap.to(toastsDialog, {
			duration: 0.7,
			x: '-50%',
			ease: 'elastic.out',
		})
	}

	function handleOk() {
		$('.wl-toasts').remove()
		BODY.removeClass(CLASS._noscroll).removeAttr('style')
		settings.onComplete()
	}

	function handleConfirm() {
		handleOk()
	}

	init()
}
